import { apiRoleMappingPagingAction } from '@app/store/reducers/apiRoleMapping';
import { loginUser, logoutUser, refreshTokenFunc } from '@app/store/reducers/auth';
import { persistor } from '@app/store/store';
import { BaseGatewayAuth } from '@app/utils/apiUrl';
import { FLASH_KEY } from '@app/utils/define';
import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

export const listenerMiddleware = createListenerMiddleware();

// listenerMiddleware.startListening({
//   actionCreator: loginUser.rejected,
//   effect: async (_action, listenerApi) => {
//     await persistor.flush();
//     await persistor.purge();
//   }
// });

// listenerMiddleware.startListening({
//   actionCreator: refreshTokenFunc.rejected,
//   effect: async (_action, listenerApi) => {
//     await persistor.flush();
//     await persistor.purge();
//   }
// });

listenerMiddleware.startListening({
  matcher: isAnyOf(apiRoleMappingPagingAction.fulfilled),
  effect: async (action, listenerApi) => {
    const items = action.payload?.data ?? [];
    if (items.length === 0) {
      localStorage.setItem(FLASH_KEY, JSON.stringify({
        level: 'error',
        text: 'Tài khoản này không được sử dụng phần mềm này'
      }));

      try {
        await persistor.flush();
        await persistor.purge();
      } catch {}

      listenerApi.cancelActiveListeners();

      const returnUrl = encodeURIComponent(window.location.origin + '/logged-out');
      window.location.href = `${BaseGatewayAuth}/connect/logout?post_logout_redirect_uri=${returnUrl}`;
      // Optionally: cancel queued reducers (ngăn render)
    }
  }
});

listenerMiddleware.startListening({
  actionCreator: logoutUser,
  effect: async () => {
    await persistor.flush();
    await persistor.purge();
  }
});

// // listeners.js
// import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
// import { apiRoleMappingPagingAction } from '@app/store/reducers/apiRoleMapping';
// import { logoutUser } from '@app/store/reducers/auth';
// import { FLASH_KEY } from '@app/utils/define';
// import { BaseGatewayAuth } from '@app/utils/apiUrl';
// import { userManager } from '@app/utils/oidc';

// export const listenerMiddleware = createListenerMiddleware();

// export function setupListeners({ startListening, purgePersist }) {
//   console.log('[listeners] setupListeners called');

//   // Nghe trực tiếp actionCreator để tránh lệch instance
//   startListening({
//     matcher: isAnyOf(apiRoleMappingPagingAction.rejected),
//     effect: async (action, listenerApi) => {
//       const items = action?.payload?.data ?? [];
//       if (items.length === 0) {
//         try {
//           localStorage.setItem(FLASH_KEY, JSON.stringify({
//             level: 'error',
//             text: 'Tài khoản này không được sử dụng phần mềm này'
//           }));
//         } catch {}

//         try {
//           await purgePersist();
//         } catch {}

//         listenerApi.cancelActiveListeners();

//         userManager.remove();

//         const returnUrl = encodeURIComponent(window.location.origin + '/logged-out');
//         window.location.href =
//           `${BaseGatewayAuth}/connect/logout?post_logout_redirect_uri=${returnUrl}`;
//       }
//     }
//   });

//   startListening({
//     actionCreator: logoutUser,
//     effect: async () => {
//       try { await purgePersist(); } catch {}
//     }
//   });
// }

